import { useContext, useState } from 'react';
import {
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
} from '@mui/material';

import { IncomeFileUploadDialog } from '../../../../../components/LoansScreen';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import {
  TableCell as StyledTableCell,
  TableRow as StyledTableRow,
} from '../../../../../components/common/Table';
import { Grid, Button } from '../../../../../components/common';
import AccordionFormContext from '../../../../../store/accordion-form-context';

export default function AdditionalDocuments(props) {
  const accordionCTX = useContext(AccordionFormContext);
  const [openIncomeFile, setOpenIncomeFile] = useState(false);
  const [incomeFileConfirmationID, setIncomeFileConfirmationID] = useState(-1);
  const [incomeType, setIncomeType] = useState('');
  const [removalIndex, setRemovalIndex] = useState(-1);

  const handleConfirmationSetup = async (id, index, type) => {
    setIncomeFileConfirmationID(id);
    setRemovalIndex(index);
    setIncomeType(type);
  };

  const deleteAdditionalProduction = (index, type) => {
    if (type === 'additional') {
      let array = [...accordionCTX.form.additionalProductionResponses];
      array.splice(index, 1);
      accordionCTX.changeFormValue('additionalProductionResponses', array);
    } else if (type === 'animal') {
      let array = [...accordionCTX.form.animalProductionResponses];
      array.splice(index, 1);
      accordionCTX.changeFormValue('animalProductionResponses', array);
    } else if (type === 'liability') {
      let array = [...accordionCTX.form.financialLiabilityResponses];
      array.splice(index, 1);
      accordionCTX.changeFormValue('financialLiabilityResponses', array);
    }
  };

  return (
    <>
      <Accordion
        square
        expanded={accordionCTX.navigation.expanded === 'panel8'}
        onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel8')}
      >
        <AccordionSummary aria-controls="panel8d-content" id="panel8d-header">
          <h1>8. Dodatkowe dokumenty</h1>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            {accordionCTX.form.animalProductionResponses.length > 0 && (
              <>
                <Grid
                  infoCard
                  topMargin
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                  component={Paper}
                >
                  <Typography variant="h4">Produkcja zwierzęca</Typography>
                </Grid>
                <Grid
                  topMargin
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                >
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell align="left">
                            Nazwa produkcji zwierzęcej
                          </StyledTableCell>
                          <StyledTableCell align="right" />
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {accordionCTX.form.animalProductionResponses.map(
                          (row, index) => (
                            <StyledTableRow key={index}>
                              <StyledTableCell component="th" scope="row">
                                {row.name}
                              </StyledTableCell>
                              <StyledTableCell
                                component="th"
                                scope="row"
                                align={'right'}
                              >
                                <Button
                                  onClick={async () => {
                                    await handleConfirmationSetup(
                                      row.id,
                                      index,
                                      'animal'
                                    ).then(() => {
                                      setOpenIncomeFile(true);
                                    });
                                  }}
                                  variant="contained"
                                >
                                  Potwierdź dochód z produkcji zwierzęcej
                                </Button>
                              </StyledTableCell>
                            </StyledTableRow>
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            )}
            {accordionCTX.form.additionalProductionResponses.length > 0 && (
              <>
                <Grid
                  infoCard
                  topMargin
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                  component={Paper}
                >
                  <Typography variant="h4">Dodatkowe źródła dochodu</Typography>
                </Grid>
                <Grid
                  topMargin
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                >
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell align="left">
                            Nazwa źródła dochodu
                          </StyledTableCell>
                          <StyledTableCell align="right" />
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {accordionCTX.form.additionalProductionResponses.map(
                          (row, index) => (
                            <StyledTableRow key={index + '_2'}>
                              <StyledTableCell component="th" scope="row">
                                {row.name}
                              </StyledTableCell>
                              <StyledTableCell
                                component="th"
                                scope="row"
                                align={'right'}
                              >
                                <Button
                                  onClick={async () => {
                                    await handleConfirmationSetup(
                                      row.id,
                                      index,
                                      'additional'
                                    ).then(() => {
                                      setOpenIncomeFile(true);
                                    });
                                  }}
                                  variant="contained"
                                >
                                  Potwierdź dodatkowe źródło dochodu
                                </Button>
                              </StyledTableCell>
                            </StyledTableRow>
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            )}
            {accordionCTX.form.financialLiabilityResponses.length > 0 && (
              <>
                <Grid
                  infoCard
                  topMargin
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                  component={Paper}
                >
                  <Typography variant="h4">Obciążenia finansowe</Typography>
                </Grid>
                <Grid
                  topMargin
                  item
                  xs={12}
                  justifyContent="center"
                  alignItems="center"
                >
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <StyledTableRow>
                          <StyledTableCell align="left">
                            Nazwa obciążenia
                          </StyledTableCell>
                          <StyledTableCell align="right" />
                        </StyledTableRow>
                      </TableHead>
                      <TableBody>
                        {accordionCTX.form.financialLiabilityResponses.map(
                          (row, index) => (
                            <StyledTableRow key={index + '_3'}>
                              <StyledTableCell component="th" scope="row">
                                {row.name}
                              </StyledTableCell>
                              <StyledTableCell
                                component="th"
                                scope="row"
                                align={'right'}
                              >
                                <Button
                                  onClick={async () => {
                                    await handleConfirmationSetup(
                                      row.id,
                                      index,
                                      'liability'
                                    ).then(() => {
                                      setOpenIncomeFile(true);
                                    });
                                  }}
                                  variant="contained"
                                >
                                  Potwierdź obciążenie finansowe
                                </Button>
                              </StyledTableCell>
                            </StyledTableRow>
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </>
            )}
            <Grid
              topMargin
              container
              justifyContent="center"
              alignItems="center"
            >
              <Button
                variant="contained"
                onClick={() =>
                  accordionCTX.changeNavigation('UNLOCK', 'panel9')
                }
              >
                Nie mam już więcej plików potwierdzających, chcę przejść dalej
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <IncomeFileUploadDialog
        open={openIncomeFile}
        handleAction={setOpenIncomeFile}
        incomeID={incomeFileConfirmationID}
        incomeType={incomeType}
        handleArray={deleteAdditionalProduction}
        loanID={accordionCTX.form.loanApplicationID}
        removalIndex={removalIndex}
      />
    </>
  );
}
